import React from "react";

const LABELS = { days: "Días", hours: "Horas", minutes: "Min", seconds: "Seg" };

function diff(target) {
  const ms = Math.max(0, new Date(target).getTime() - Date.now());
  return {
    days: Math.floor(ms / 864e5),
    hours: Math.floor(ms / 36e5) % 24,
    minutes: Math.floor(ms / 6e4) % 60,
    seconds: Math.floor(ms / 1e3) % 60,
  };
}

/** Live countdown to the wedding date, shown as four tracked numerals. */
export function Countdown({ target, tone = "default", boxed = false, style }) {
  const [t, setT] = React.useState(() => diff(target));
  React.useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const muted = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 60%, transparent)" : "var(--fg-muted)";
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: boxed ? "var(--sp-2)" : "var(--sp-1)", ...style }}>
      {Object.keys(LABELS).map((k) => (
        <div key={k} style={{
          textAlign: "center", padding: boxed ? "var(--sp-4) var(--sp-2)" : "0",
          border: boxed ? "var(--border-hair) solid var(--rule)" : "none",
          background: boxed ? "var(--bg-elevated)" : "transparent",
        }}>
          <div style={{ fontFamily: "var(--font-title, var(--font-display))", fontSize: "var(--fs-title-l)", fontWeight: "var(--fw-light)", lineHeight: 1, color: fg, fontVariantNumeric: "lining-nums tabular-nums" }}>
            {String(t[k]).padStart(2, "0")}
          </div>
          <div style={{ marginTop: 8, fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body)", color: muted }}>
            {LABELS[k]}
          </div>
        </div>
      ))}
    </div>
  );
}
